import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/PatientInfo/Patientmap`;

export const getPatientMap = async ({
  locationId,
  memberType,
  pcpName,
  gender,
  ageFrom,
  ageTo,
  memberId,
  memberFullName,
  filterAdmitted,
  filterDischarged,
  filterEmergency,
  filterHighCost,
  filterHighRisk,
  page = 1,
  pageSize = 50
}) => {
  try {
    const params = {
      locationId,
      memberType,
      pcpName,
      gender,
      ageFrom,
      ageTo,
      memberId,
      memberFullName: memberFullName ? memberFullName.toUpperCase() : memberFullName,
      filterAdmitted,
      filterDischarged,
      filterEmergency,
      filterHighCost,
      filterHighRisk,
      page,
      pageSize
    };

    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      params
    });

    return response.data; // Será un PatientMapPageResultDto
  } catch (error) {
    console.error("Error fetching patient map:", error);
    throw error;
  }
};
